import React, { useState } from 'react'
import styled from 'styled-components'
import { Borders, Colors, Fonts, FontWeights } from '../../constants'
import { useTransactions } from '../../hooks'
import { isPending } from '../../providers/transactions/model'
import { logAmplitudeEvent } from '../../utils'
import { HistoryModal } from './HistoryModal'

export function HistoryButton() {
  const { transactions } = useTransactions()
  const [open, setOpen] = useState(false)
  const pending = transactions.filter((tx) => isPending(tx))

  return (
    <>
      <Button
        onClick={() => {
          setOpen(true)
          logAmplitudeEvent('History: Open Modal')
        }}
      >
        {pending.length > 0 && <Pending numberPending={pending.length}>{`${pending.length} Pending`}</Pending>}
        History
      </Button>
      {open && <HistoryModal onClose={() => setOpen(false)} />}
    </>
  )
}

const Button = styled.button`
  padding: 0 8px;
  display: block;
  height: 41px;
  color: ${Colors.LightererGray};
  font-size: 13px;
  font-family: ${Fonts.Header};
  font-weight: ${FontWeights.Semibold};
  text-transform: uppercase;
  text-decoration: none;
  text-align: center;
  background: none;
  border: 0;
  outline: 0;
  cursor: pointer;

  &.active {
    color: ${Colors.White};
    background-color: #00000020;
    border-radius: ${Borders.Radius};
  }

  &:hover {
    color: ${Colors.White};
  }
`

interface PendingProps {
  numberPending: number
}

const Pending = styled.small.attrs((props: PendingProps) => ({
  numberPending: props.numberPending,
}))`
  margin-bottom: 4px;
  padding: 0 5px;
  display: block;
  color: ${(props) => (props.numberPending > 0 ? Colors.White : 'inherit')};
  font-size: 8px;
  border-radius: 6px;
  background-color: ${(props) => (props.numberPending > 0 ? Colors.Red : 'inherit')};
`
